import React from 'react';
import {Card} from '@rneui/themed';

import {JoinMoreRewardsCTA} from '../../../components/rewards/JoinMoreRewards';
import Text from '../../../components/themed/Text';
import {rewardsMarketingName} from '../../../utils/rewards';

function CartJoinRewards({navigation}: {navigation: any}) {
  return (
    <Card noMargin gap={12} variant="outlined">
      <Text noMargin variant="heading2">
        Save with {rewardsMarketingName}
      </Text>
      <Text variant="body2">
        Join {rewardsMarketingName} today and start enjoying free member
        benefits at your fingertips.
      </Text>
      <JoinMoreRewardsCTA navigation={navigation} />
    </Card>
  );
}

export default CartJoinRewards;
